export const SET_PRODUCTS: string = 'SET_PRODUCTS';
export const SET_OTHER_PRODUCTS: string = 'SET_OTHER_PRODUCTS';
export const SET_MESSAGES: string = 'SET_MESSAGES';
export const SET_THEME: string = 'SET_THEME';
export const SET_LAYOUT: string = 'SET_LAYOUT';
export const SET_BANNER: string = 'SET_BANNER';
export const RESET: string = 'RESET';
export const RESET_PRODUCTS: string = 'RESET_PRODUCTS';
